<template>
  <div v-show='cpntMostrar' class="cpnt-app-autocompletar cpnt-app-campo" :class='cpntAutoCompletarMontarClass'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <!-- SETA O CAMPO DE AUTOCOMPLITE -->
      <autocomplete :class="(cpntNewOption !== null && cpntDisabled === false) ? 'com-new-option' : ''"
        :tabIndex='cpntTabIndex'
        :auto-select="true"
        :data-expanded="false"
        :disabled="cpntDisabled"
        :debounceTime="100"
        :aria-label="cpntPlaceholder"
        :get-result-value="cpntAutoCompletarGetResultValue"
        :search="cpntAutoCompletarBuscarValor"
        @submit="cpntAutoCompletarSubmitValue"
        @focus="cpntAutoCompletarOnFocus"
        @blur="cpntAutoCompletarOnBlur"
      ref="autocompletar"></autocomplete>
      <ul v-if="cpntNoOptions === true && options !== null && options.length === 0" id="autocomplete-result-list-2" role="listbox" class="autocomplete-result-list" style="position: absolute; z-index: 1; width: 100%; visibility: visible; pointer-events: auto; top: 100%; max-height: 237px;"><li id="autocomplete-result-0" data-result-index="0" role="option" aria-selected="true" class="autocomplete-result">
        <span>Nenhum registro encontrado.</span>
      </li></ul>

      <!-- ADICIONA O BOTÃO PARA NOVO OPTION -->
      <RF-Button :data-time='time' v-if="cpntNewOption !== null && cpntDisabled === false"
        :cpntStatus='cpntNewOption.status' 
        :cpntId='cpntNewOption.id' 
        :cpntTipo='cpntNewOption.tipo' 
        :cpntIcone='cpntNewOption.icone' 
        :cpntTexto='cpntNewOption.texto' 
        :cpntClass='cpntNewOption.class'
        :cpntDisabled="cpntDisabled"
        :cpntMostrar='cpntNewOption.mostrar'
        :cpntExplica='cpntNewOption.explica'
        :cpntTabIndex='cpntNewOption.tabIndex'
        @onClickButton='() => { cpntNewOption.onClick(busca, cpntId) }'
      ></RF-Button>

      <!-- SETA A BARRA QUE APRESENTA ABAIXO DO INPUT -->
      <span class="cpnt-barra"></span>

      <!-- SETA O TITULO DO CAMPO -->
      <label>
        <!-- SETA O NOME DO CMAPO -->
        <span v-html='cpntNome'></span>

        <!-- COLOCA A EXPLICAÇÃO DO CAMPO -->
        <App-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'
        ></App-Explica>
      </label>

      <!-- SETA A MENSAGEM DE ERRO DO CAMPO -->
      <span class="cpnt-has-error" v-if="[ '', null, undefined ].indexOf(cpntMensagem) === -1" v-html='cpntMensagem'></span>
    </template>
  </div>
</template>

<style>
  .cpnt-app-autocompletar {
    width: 100%;
    position: relative;
  }
    .cpnt-app-autocompletar > .cpnt-barra {
      top: 2px;
    }
  .cpnt-app-autocompletar > div > div > input {
    text-align: left;
    background: #fff;
    top: 1px;
    font-size: inherit;
    color: inherit;
  }
  .cpnt-app-autocompletar > div > div > input ~ ul {
    text-align: left;
  }
  .autocomplete-result {
    background: none;
    padding: 5px 5px 5px 5px;
    cursor: pointer;
  }
  .cpnt-app-autocompletar > div {
      vertical-align: initial;
    }
    .cpnt-app-autocompletar > .com-new-option {
      display: inline-block;
      width: calc(100% - 33px);
    }
    .cpnt-app-autocompletar > .com-new-option ~ button {
      display: inline-block;
      height: 30px;
      margin-top: -1px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      opacity: 0.75;
    }
  
  .cpnt-app-autocompletar > .com-new-option ~ button:hover {
    opacity: 1;
  }
  .cpnt-app-autocompletar > .com-new-option > div > input {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .cpnt-autocomplite-drop-in-dialog > ul,
  .cpnt-autocomplite-drop-in-dialog > div > div > ul {
    position: fixed !important;
    width: 333px !important;
    max-width: 333px !important;
    top: auto !important;
    bottom: auto !important;

    max-height: 270px;
    overflow-y: auto;
  }

  .cpnt-app-autocompletar > div > div > ul > .autocomplete-result:hover, 
  .cpnt-app-autocompletar > div > div > ul > .autocomplete-result[aria-selected=true] {
    background: #3875d7 !important;
    color: #fff !important;
  }
</style>

<script>
  import '@trevoreyre/autocomplete-vue/dist/style.css'

  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-select-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntStatus: {
        required: true
      },
      cpntField: {
        type: Object,
        required: false
      },
      cpntFieldVirtual: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },
      cpntWhere: {
        type: [ Object, String, Function ],
        required: false,
        default: function () {
          return {}
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntRouter: {
        type: String,
        required: false
      },
      cpntMethod: {
        type: String,
        required: false,
        default: function () {
          return 'GET'
        }
      },
      cpntKeyMostra: {
        type: Array,
        required: true
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntNoOptions: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntValue: {
        required: true,
        type: [ Object, String, Number ]
      },
      cpntNewOption: {
        required: false,
        default: function () {
          return null
        }
      },

      cpntOnBuscarOptions: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnFocus: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnBlur: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntInputOnKeyUp: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntInputOnKeyDown: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnRealizaBusca: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'Autocomplete': () => import('@trevoreyre/autocomplete-vue'),
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        options: null,
        classes: [],
        busca: '',
        buscar: false,
        calculando: false,
        observador: false
      }
    },
    destroyed: function () {
      this.calculando = false
    },
    mounted: function () {
      this.cpntAutoCompletarIniciar()
    },
    methods: {
      cpntAutoCompletarSetarObservador: function (tentativa = 0) {
        if (tentativa <= 10 && this.observador === false && (this.cpntInputOnKeyUp !== null || this.cpntInputOnKeyDown !== null)) {
          if ([ '', null, undefined ].indexOf(this.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.autocompletar) !== -1  || [ '', null, undefined ].indexOf(this.$refs.autocompletar.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.autocompletar.$refs.input) !== -1) {
            setTimeout(() => { this.cpntAutoCompletarSetarObservador((tentativa + 1)) }, 100)  
          } else {
            // SETA QUE O OBSERVADOR FOI SETADO
            this.observador = true

            // ADICIONA O OBESERVADOR
            if (this.cpntInputOnKeyUp !== null) {
              this.$refs.autocompletar.$refs.input.addEventListener('keyup', (event) => { this.cpntInputOnKeyUp(event) })
            }

            // ADICIONA O OBESERVADOR
            if (this.cpntInputOnKeyDown !== null) {
              this.$refs.autocompletar.$refs.input.addEventListener('keydown', (event) => { this.cpntInputOnKeyDown(event) })
            }
          }
        }
      },
      cpntAutoCompletarIniciar: function () {
        // CHAMA A FUNÇÃO PARA SETAR O OBSERVADOR
        setTimeout(() => { this.cpntAutoCompletarSetarObservador() }, 0)

        // VERIFICA SE EXISTE DIFERENTEÇA DE VALOR
        if (this.busca !== this.cpntValue) {
          // LIMPA O CAMPO BUSCA PARA NÃO FAZER UMA NOVA BUSCA
          this.busca = [ '', null, undefined ].indexOf(this.cpntValue) === -1 && typeof this.cpntValue === 'object' ? this.cpntAutoCompletarGetResultValue(this.cpntValue) : this.cpntValue
  
          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          if ([ '', null, undefined ].indexOf(this.cpntValue) === -1 && typeof this.cpntValue === 'object' && Object.keys(this.cpntValue).length >= 1) {
            this.cpntAutoCompletarAtualizarValorSelecionado(this.cpntValue)
          } else {
            this.cpntAutoCompletarAtualizarValorSelecionado('')
          }
        }
      },
      cpntAutoCompletarBuscarValor: function (busca, where = null, forcar = false) {
        return new Promise((success) => {
          // CHAMA A FUNÇÃO PARA INFORMAR QUE FOI DIGITADO ALGUAM COISA
          if (this.busca !== busca && this.cpntOnRealizaBusca !== null && typeof this.cpntOnRealizaBusca === 'function') {
            this.cpntOnRealizaBusca(busca, this.cpntId)
          }

          // VERIFICA SE TEM QUE BUSCAR
          if (this.busca !== busca && this.buscar === false && busca.length >= 2) {
            this.buscar = true
          }
  
          // SETA O VALOR RECEBIDO
          this.busca = [ '', null, undefined ].indexOf(busca) !== -1 ? '' : busca

          // VERIFICA SE FOI SELECIONADO ALGUM ITEM
          if (this.cpntRouter === '' || (forcar === false && (this.buscar === false || [ '', null, undefined ].indexOf(busca) !== -1 || busca.length < 2))) {
            // LIMPA OS OPTIONS EXISTENTES
            this.options = null

            // FINALIZA O PROCESSO
            success([])
          } else {
            if (this.cpntOnBuscarOptions !== null) {
              this.cpntOnBuscarOptions(busca, (registros) => { this.cpntAutoCompletarSetarValores(registros, success) }, this.cpntId)
            } else {
              // INICIA O QUERY GET QUE SERÁ REALIZADO NA API
              var queryGet = { type: 'list', field: this.cpntField, where: {}, limit: { row: 0, qty: 100 } }

              // VERIFICA SE DEVE INFORMAR CAMPO VIRTUAL
              if ([ '', null, undefined ].indexOf(this.cpntFieldVirtual) === -1 && this.cpntFieldVirtual.length >= 1) {
                queryGet.field_virtual = this.cpntFieldVirtual
              }

              // CRIA PROMISSE PARA MONTAR O WHERE
              new Promise((successW) => {
                if (where === null && [ '', null, undefined ].indexOf(this.cpntWhere) === -1) {
                  if (typeof this.cpntWhere === 'function') {
                    // CARREGA OS DADOS DO CAMPO
                    var whereRet = this.cpntWhere(this.cpntId)
                    
                    // VERIFICA SE O RETORNO É UM PROMISSE OU NÃO
                    if (typeof whereRet === 'object' && typeof whereRet.then === 'function') {
                      whereRet.then((retorno) => {
                        // PEGA O WHERE RECEBIDO
                        queryGet.where = retorno

                        // FINALIZA O CARREGAMENTO
                        successW()
                      })
                    } else {
                      // PEGA O WHERE RECEBIDO
                      queryGet.where = whereRet

                      // FINALIZA O CARREGAMENTO
                      successW()
                    }
                  } else {
                    // PEGA O WHERE RECEBIDO
                    queryGet.where = this.cpntWhere

                    // FINALIZA O CARREGAMENTO
                    successW()
                  }
                } else if (where !== null) {
                  // PEGA O WHERE RECEBIDO
                  queryGet.where = where

                  // FINALIZA O CARREGAMENTO
                  successW()
                }
              }).then(() => {
                // PEGA O WHERE RECEBIDO
                queryGet.where = JSON.stringify(queryGet.where)
    
                // CONVERTE TODOS OS VALORES DE BUSCA
                while (queryGet.where.indexOf('#BUSCA#') !== -1) {
                  queryGet.where = queryGet.where.replace('#BUSCA#', busca)
                }
    
                // CONVERTE O VALOR EM OBJETO
                queryGet.where = JSON.parse(queryGet.where)
      
                // VERIFICA O WHERE QUE DEVE MONTAR
                if (typeof queryGet.where === 'string') {
                  switch (queryGet.where) {
                    case 'dem-edi-ser':
                    case 'dem-edi-pro':
                      queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: busca } ] }
                      break
      
                    default:
                      queryGet.where = { o: 's.ft', v: busca }
                      break
                  }
                }
                
                // CHAMA FUNÇÃO PARA COMUNICAR COM API
                this.$store.state.comunicaAPI(this.cpntRouter, this.cpntMethod, queryGet, (apiSuccess) => {
                  this.cpntAutoCompletarSetarValores(apiSuccess.data, success)
                }, this.cpntAutoCompletarSetarStatusGeral)
              })    
            }
          }
        })
      },
      cpntAutoCompletarSetarValores: function (registros, success) {
        // LIMPA OS OPTIONS EXISTENTES
        this.options = registros

        // FINALIZA O PROCESSO
        success(this.options)
      },
      cpntAutoCompletarGetResultValue: function (result) {
        // INICIA A CHAVE PARA O VALOR
        var valor = ''

        // MONTA O VALOR DO OPTION
        if (typeof result === 'object' && Array.isArray(result) === false) {
          for (var indexV in this.cpntKeyMostra) {
            // PEGA O NOME DA CHAVE
            var chave = this.cpntKeyMostra[indexV]
  
            // VERIFICA SE A CHAVE EXISTE E SE TEM VALOR A SER MONTADO
            if (result[chave] !== undefined) {
              // VERIFICA SE TEM QUE FORMATAR O VALOR
              if ([ '/produto/get' ].indexOf(this.cpntRouter) !== -1 && [ 'valor_for', 'valor_ven' ].indexOf(chave) !== -1) {
                valor += this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', result[chave])
              } else if (indexV === 'placa') {
                valor += result[chave].toUpperCase()
              } else {
                valor += result[chave]
              }
            } else {
              valor += chave
            }
          }
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      cpntAutoCompletarSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntAutoCompletarSubmitValue: function (value, insert = false) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }
        
        // VERIFICA SE DEVE BUSCAR O ITEM
        if (value === undefined && this.busca.length === 0 && [ 'dem-edi-pro' ].indexOf(this.cpntWhere) !== -1) {
          // PEGA O VALOR BUSCADO
          var busca = this.$refs.autocompletar.$refs.input.value

          // SETA O WHERE QUE DEVE REALIZAR
          var where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'cod_barra', o: '=', v: busca } ] }

          // SETA O VALOR DA BUSCA
          this.busca = busca
          
          // FAZ A BUSCA DOS CADASTROS
          this.cpntAutoCompletarBuscarValor(busca, where, true).then((vetor) => {
            if(vetor.length === 1) {
              this.cpntAutoCompletarSubmitValue(vetor[0], true)
            }
          })
        } else if ([ '', null, undefined ].indexOf(value) === -1) {
          // SETA A VARIAVEL QUE INFORMA QUE DEVE INSERIR OU NÃO O ITEM
          value.__INSERT_VALUE__ = insert

          // FAZ O ONCHANGE DO VALOR SELECIONADO
          this.cpntOnChange(value, this.cpntId)
        }
      },
      cpntAutoCompletarAtualizarValorSelecionado: function (value = '', tentativa = 0) {
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs.autocompletar) !== -1 || [ '', null, undefined ].indexOf(this.$refs.autocompletar.setValue) !== -1) {
            setTimeout(() => { this.cpntAutoCompletarAtualizarValorSelecionado(value, (tentativa + 1)) }, 100)
          } else {
            this.$refs.autocompletar.setValue(value)
          }
        }
      },
      cpntRealizarFocus: function (tentativa = 0) {
        if (tentativa <= 10) {
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs.autocompletar) === -1 && [ '', null, undefined ].indexOf(this.$refs.autocompletar.$refs.input) === -1) {
            // SETA O FLAG SE DEVE BUSCAR OU NÃO
            this.buscar = false

            // SETA O FOCUS NO CAMPO
            this.$refs.autocompletar.$refs.input.focus()
            this.$refs.autocompletar.$refs.input.select()

            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_POSICIONAR_SCROLL_FOCUS_CAMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_POSICIONAR_SCROLL_FOCUS_CAMPO

            // EXECUTA A FUNÇÃO IMPORTADA
            FUN_POSICIONAR_SCROLL_FOCUS_CAMPO(this.$refs.autocompletar.$refs.input)
          } else {
            setTimeout(() => { this.cpntRealizarFocus((tentativa + 1)) }, 100)
          }
        }
      },
      cpntAutoCompletarDestacarCampo: function (destacar = false) {
        // INICIA A VARIAVEL
        var classes = []

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (destacar) {
          case true:
            classes = [ 'cpnt-app-campo-focus' ]
            break

          case false:
          default:
            break
        }

        // INICIA A VARIAVEL
        var parar = false

        // PEGA O CAMPO QUE ESTÁ SENDO CARREGADO
        var target = this.$refs.autocompletar.$el

        // PROCURA O ELEMENTO PAI PRA SABER SE ESTÁ DENTRO DE UM SELECT2
        while (parar === false) {
          if (target.tagName === 'BODY' || target.className.indexOf('app-dialog') !== -1) {
            parar = true
          } else {
            target = target.parentElement
          }
        }

        // VERIFICA SE DEVE INCLUIR A CLASS PARA DIALOG
        if (target.className.indexOf('app-dialog') !== -1) {
          // ADICIONA A CLASSE NO CAMPO
          classes.push('cpnt-autocomplite-drop-in-dialog')

          // VERIFICA SE O SERVIÇO DE MONITORAMENTO ESTÁ RODANDO
          if (this.calculando === false) {
            // SETA O PROCESSO ESTÁ RODANDO
            this.calculando = true

            // INICIA O PROCESSO
            this.cpntAutoCompletarVerificarPosicao()
          }
        }

        // ADICIONA A CLASSE AO CAMPO
        this.classes = classes

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntAutoCompletarOnFocus: function () {
        // SETA O FLAG SE DEVE BUSCAR OU NÃO
        setTimeout(() => { this.buscar = true }, 1000)

        // FAZ O DESTAQUE DO CAMPO
        this.cpntAutoCompletarDestacarCampo(true)

        // REALIZA A AÇÃO SOLICITADA
        if (this.cpntOnFocus !== null) {
          this.cpntOnFocus(this.cpntId)
        }
      },
      cpntAutoCompletarOnBlur: function () {
        // SETA O FLAG SE DEVE BUSCAR OU NÃO
        this.buscar = false

        // LIMPA OS DADOS DO VETOR
        this.options = null

        // FAZ O DESTAQUE DO CAMPO
        this.cpntAutoCompletarDestacarCampo(false)

        // REALIZA A AÇÃO SOLICITADA
        if (this.cpntOnBlur !== null) {
          this.cpntOnBlur(this.cpntId)
        }
      },
      cpntAutoCompletarVerificarPosicao: function () {
        if (this.calculando === true) {
          // PEGA A LISTA DE DADOS
          var element = this.$refs.autocompletar.$refs.resultList

          // PEGA AS POSIÇÕES DA TELA
          var posicoes = element.getBoundingClientRect()

          // TAMANHO MAXIMO NA TELA
          var tamanho = (window.innerHeight - (posicoes.height + posicoes.top))

          // SETA O TAMANHO MAXIMO DO CAMPO
          element.style.maxHeight = tamanho + 'px'
        }
      }
    },
    computed: {
      cpntAutoCompletarMontarClass: function () {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = []

        // VERIFICA SE TEM ALGUMA MENSAGEM DE VALIDAÇÃO
        if ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1) {
          valor.push('cpnt-app-campo-has-error')
        }

        // JUNTA OS VALORES DO CAMPO
        valor = valor.concat(this.classes)
        
        // RETORNA O VALOR MONTADO
        return valor
      },
    },
    watch: {
      cpntValue: function () {
        this.cpntAutoCompletarIniciar()
      }
    }
  }
</script>
